/* eslint-disable */
import * as Types from '../../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
export type InvestAndTradeCheckQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvestAndTradeCheckQuery = { __typename: 'Query', offers: Array<{ __typename: 'Offer', id: string, hideOffer?: boolean | null, status: Types.OfferStatus }>, sellOrders: Array<{ __typename: 'SellOrder', id: string, status: Types.SellOrderStatus }> };


export const InvestAndTradeCheckDocument = gql`
    query InvestAndTradeCheck {
  offers {
    id
    hideOffer
    status
  }
  sellOrders {
    id
    status
  }
}
    ` as unknown as DocumentNode<InvestAndTradeCheckQuery, InvestAndTradeCheckQueryVariables>;